/*
  Canwell custom events.
  Publishes theme events to Shopify Customer Events so they can be mapped to
  GA4 and Meta in admin. Nothing here talks to gtag or fbq directly, and the
  standard commerce events (page view, product view, add to cart, checkout,
  purchase) are left to Shopify's own channel pixels.

  Events:
    get_directions  any link with data-canwell-event="get_directions"
    click_to_call   any link with data-canwell-event="click_to_call"
    form_submit     any form with data-canwell-form="name" when submitted,
                    or window.canwellTrack('form_submit', { form: 'name' })

  Every payload carries page, and where set, source and label.
  Add ?canwell_debug=1 to any URL to log events to the console for the
  rest of the browser session.
*/
(function () {
  var DEBUG_KEY = 'canwell_debug';

  function debugOn() {
    try {
      if (window.location.search.indexOf(DEBUG_KEY) !== -1) {
        window.sessionStorage.setItem(DEBUG_KEY, '1');
      }
      return window.sessionStorage.getItem(DEBUG_KEY) === '1';
    } catch (error) {
      return window.location.search.indexOf(DEBUG_KEY) !== -1;
    }
  }

  function publish(name, data) {
    var payload = Object.assign({ page: window.location.pathname }, data || {});
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload);
    }
    if (debugOn() && window.console) {
      console.info('[canwell] ' + name, payload);
    }
    document.dispatchEvent(new CustomEvent('canwell:event', { detail: { name: name, payload: payload } }));
  }

  window.canwellTrack = publish;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target.closest('[data-canwell-event]') : null;
      if (!target) return;
      var name = target.getAttribute('data-canwell-event');
      if (!name) return;
      publish(name, {
        source: target.getAttribute('data-canwell-source') || '',
        href: target.getAttribute('href') || '',
        label: (target.textContent || '').trim().slice(0, 80)
      });
    },
    { capture: true }
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form || !form.hasAttribute('data-canwell-form')) return;
      publish('form_submit', {
        form: form.getAttribute('data-canwell-form') || form.id || '',
        source: form.getAttribute('data-canwell-source') || ''
      });
    },
    { capture: true }
  );

  if (debugOn() && window.console) {
    console.info('[canwell] event debugging on for this session');
  }
})();
